module.exports = __webpack_public_path__ + "img/pay_ok.d80a552d.png";